import {
    createStyles,
    Grid,
    Theme,
    Typography,
    withStyles,
    WithStyles
} from "@material-ui/core";
import React from "react";
import Moment from "react-moment";
import Constants from "../../../models/utility/Constants";
import CountdownTimer from "./CountdownTimer";

type AuctionTimerCardProps = WithStyles<typeof styles> & {
    auctionId: string;
    auctionDate: string;
};

const WhiteTextTypography = withStyles({
    root: {
        color: "#FFFFFF"
    }
})(Typography) as typeof Typography;

const rowHeight = 95;
const styles = (theme: Theme) =>
    createStyles({
        auctionDate: {
            [theme.breakpoints.down("xs")]: { fontSize: 18 },
            color: theme.palette.common.black,
            fontSize: 20,
            whiteSpace: "nowrap"
        },
        auctionYear: {
            [theme.breakpoints.down("xs")]: { fontSize: 18 },
            color: theme.palette.common.black,
            fontSize: 20
        },
        bar: {
            color: "black",
            fontWeight: "lighter"
        },
        date: { textAlign: "right" },
        leftPart: { backgroundColor: theme.palette.primary.main },
        part: {
            [theme.breakpoints.down("xs")]: { alignItems: "center" },
            alignItems: "flex-start",
            display: "flex",
            height: rowHeight
        },
        partWrapper: { width: "100%" },
        row: { height: "100%" },
        time: { textAlign: "left" },
        timeDisplayCard: {
            [theme.breakpoints.down("xs")]: { width: 360 },
            borderColor: theme.palette.primary.main,
            borderRadius: "1rem",
            borderStyle: "solid",
            borderWidth: "0.3rem",
            height: "auto",
            textAlign: "center",
            width: 600
        },
        title: {
            [theme.breakpoints.down("xs")]: { fontSize: 14 },
            fontWeight: "bold"
        }
    });

class AuctionTimerCard extends React.PureComponent<AuctionTimerCardProps, {}> {
    public render() {
        const classes = this.props.classes;

        return (
            <div className={classes.timeDisplayCard}>
                <Grid container={true} spacing={0} className={classes.row}>
                    <Grid
                        item={true}
                        xs={12}
                        sm={6}
                        className={`${classes.part} ${classes.leftPart}`}
                    >
                        <div className={classes.partWrapper}>
                            <WhiteTextTypography
                                variant="subtitle1"
                                className={classes.title}
                                color="textSecondary"
                            >
                                AUCTION DATE
                            </WhiteTextTypography>
                            <WhiteTextTypography
                                variant="h5"
                                className={classes.auctionDate}
                            >
                                <Moment
                                    date={this.props.auctionDate}
                                    format={Constants.AuctionDateTop}
                                    tz={Constants.TimeZone}
                                />
                            </WhiteTextTypography>
                            <WhiteTextTypography
                                variant="h6"
                                className={classes.auctionYear}
                            >
                                <Moment
                                    date={this.props.auctionDate}
                                    format={Constants.AuctionDateBottom}
                                    tz={Constants.TimeZone}
                                />
                            </WhiteTextTypography>
                        </div>
                    </Grid>
                    <Grid item={true} xs={12} sm={6} className={classes.part}>
                        <div className={classes.partWrapper}>
                            <WhiteTextTypography
                                variant="subtitle1"
                                className={classes.title}
                                color="textSecondary"
                            >
                                AUCTION STARTS IN
                            </WhiteTextTypography>
                            <CountdownTimer
                                entityId={this.props.auctionId}
                                date={this.props.auctionDate}
                                maxWidth="none"
                                biggerFont={true}
                                justifyContent="center"
                            />
                        </div>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

export default withStyles(styles)(AuctionTimerCard);
